import { cx, MONO } from './classes.js';

export interface TabSpec<K extends string> {
  key: K;
  label: string;
  /** Count (or a glyph word like "✓") shown in mono after the label; omit for none. */
  count?: string | number | null;
}

/** Profile tabs (Profile artboard): accent underline on the active tab, counts in mono. */
export function Tabs<K extends string>({
  tabs,
  active,
  onChange,
  label,
}: {
  tabs: ReadonlyArray<TabSpec<K>>;
  active: K;
  onChange: (key: K) => void;
  label: string;
}) {
  return (
    <nav aria-label={label} className="flex gap-7 border-b border-line">
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(t.key)}
            className={cx(
              '-mb-px flex cursor-pointer items-center gap-1.5 border-b-2 px-0.5 pb-3 text-[14px]',
              isActive
                ? 'border-accent font-semibold text-ink'
                : 'border-transparent font-medium text-mute hover:text-ink',
            )}
          >
            {t.label}
            {t.count !== undefined && t.count !== null ? (
              <span className={cx(MONO, 'text-[12px] text-mute')}>{t.count}</span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
